export const BOT_REDIRECT = 'redirect';

export const INTEGRATION_DATA = 'integrationData';
